import { getClaimOrigin } from "../api/claimOriginApi";
import GenericDictionaryPage from "./GenericDictionaryPage";

export default function ClaimOrigin() {
    return (
        <GenericDictionaryPage
            tableKey="claimOrigin"
            fetchData={getClaimOrigin}
            titleKey="genericDic:claimOrigin"
            newButtonLabel={({ t }) =>
                t("genericDic:claimReopenReasonButtonNew", {
                    tableName: t("genericDic:claimOrigin").toLowerCase()
                })
            }
        />
    );
}
